import { NumericAspect, RangeAspect } from "@/models/HomePageSearchResponse";
import { Box, FormControl, FormLabel, MenuItem, Select } from "@mui/material";

function RangeValueSelect({
  label,
  aspectKey,
  value,
  options,
  onChange,
}: {
  label: string;
  aspectKey: string;
  value: number;
  options: NumericAspect[];
  onChange: (value: number) => void;
}) {
  return (
    <FormControl size="small">
      <Select
        id={aspectKey + "-min-select"}
        value={value}
        onChange={(e) => onChange(e.target.value as number)}
        sx={{ minWidth: 60 }}
        displayEmpty
      >
        <MenuItem value={-1}>
          <FormLabel>{label}</FormLabel>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default function RangeSelect({
  aspectKey,
  options,
  value,
  onChange,
}: {
  aspectKey: string;
  options: NumericAspect[];
  value: RangeAspect;
  onChange: (value: RangeAspect) => void;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
      }}
    >
      <RangeValueSelect
        label="Min"
        aspectKey={aspectKey}
        value={value.min}
        options={options}
        onChange={(minValue) => onChange({ ...value, min: minValue })}
      />
      <RangeValueSelect
        label="Max"
        aspectKey={aspectKey}
        value={value.max}
        options={options}
        onChange={(maxValue) => onChange({ ...value, max: maxValue })}
      />
    </Box>
  );
}
